import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	testingCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.testing-category',
		defaultMessage: 'Testing',
		description:
			'This will be shown as a suggested category for related work items. Here `Testing` refers to the usual meaning of testing a software feature or component.',
	},
	rolloutCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.rollout-category',
		defaultMessage: 'Rollout',
		description:
			'This will be shown as a suggested category for related work items. Here `Rollout` refers to rolling out of a feature or update to a software.',
	},
	analyticsCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.analytics-category',
		defaultMessage: 'Analytics',
		description:
			'This will be shown as a suggested category for related work items. "Analytics" here refers to product usage analytics. Work items in this category will typically be things like Google Analytics or Amplitude dashboards.',
	},
	communicationCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.communication-category',
		defaultMessage: 'Communication',
		description:
			'This will be shown as a suggested category for related work items. "Communication" here refers to communication tools. Work items in this category will typically be things like Slack channels or Zoom rooms.',
	},
	developmentCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.development-category',
		defaultMessage: 'Development',
		description:
			'This will be shown as a suggested category for related work items. "Development" here refers to software development. Work items in this category will typically be things like source code repositories or test results.',
	},
	supportCategory: {
		id: 'software-releases-version-related-work-categories.common.default-categories.support-category',
		defaultMessage: 'Support',
		description:
			'This will be shown as a suggested category for related work items. "Support" here refers to software support. Work items in this category will typically be things like support rosters or documentation pages.',
	},
});
